export enum MysMoveUseCase {
  WHOLE = 'whole',
  STUFF = 'just_big_stuff',
}
export enum MysSubMoveUseCase {
  HELPERS_TRUCK = 'helpers_truck',
  HELPERS_ONLY = 'helpers_only',
}

export type MysEdges = {
  HOME: string;
  LANDING: string;
  VIEWED: string;
  BOOKED: string;
  HELP_NEEDED: string;
  QUANTITY: string;
};

export type MysEdgesProp = Partial<MysEdges>;

export enum DollyStatus {
  TaskStatusUnspecified = 'TASKSTATUS_UNSPECIFIED',
  Viewed = 'VIEWED',
  Cancelled = 'CANCELLED',
  Created = 'CREATED',
  Completed = 'COMPLETED',
}

export enum InternalDollyStatus {
  TaskStatusUnspecified = 'taskstatus_unspecified',
  Viewed = 'viewed',
  Cancelled = 'cancelled',
  Created = 'created',
  Completed = 'completed',
}

export type MysDollyData = {
  moveId: string;
  fromAddress: string;
  toAddress: string;
  moveDate: string;
  firstName: string;
  lastName: string;
  moveUseCase: string;
  homeSize: string;
  email: string;
  returnUrl: string;
};
